import React from "react";
import { Typography } from "@mui/material";
import { MainPageLoader } from "../../components/MainPageLoader";
import { SearchInput, CustomTableFooter } from "../../components";
import LandingPageAGgrid from "./LandingPageAGGrid";
import { ApiService } from "../../utils/ApiService";
import { API_URL } from "../../utils/Constants";
import PropTypes from "prop-types";
import { LANDING_PAGE_CONSTANTS } from "../../config/constants";
import { MAX_WIDTH } from "../../config/styles";

const WelcomePage = ({
  pageSize,
  onPageSizeChanged,
  pageNo,
  totalCount,
  onLeftArrow,
  onRightArrow,
  searchString,
  onSearch,
  studentValueList,
  onSync,
  showSnack,
  onCloseSnack,
  snackMsg,
  loader,
  ...props
}) => {
  let firstName = localStorage.getItem("firstName");
  const onboardMerchants = async (selectedData, eppType) => {
    const merchantIds = selectedData.map((merchant) => merchant.merchantId);

    const payload = {
      eppType: eppType, // This could be 'visa' or 'rakbank'
      merchantIds: merchantIds, // Array of merchant IDs
    };

    try {
      const response = await ApiService.postRequest(
        API_URL.ONBOARD_MERCHANTS_TO_EPP,
        payload
      );
      if (response.status.code === "Y") {
        alert(
          `${LANDING_PAGE_CONSTANTS.ALERT_SUCCESS1} ${eppType?.toUpperCase()}${
            LANDING_PAGE_CONSTANTS.ALERT_SUCCESS2
          }`
        );
      } else {
        alert(LANDING_PAGE_CONSTANTS.ALERT_FAILURE + response.status.message);
      }
    } catch (error) {
      console.error(LANDING_PAGE_CONSTANTS.ERROR_CONSOLE, error);
      alert(LANDING_PAGE_CONSTANTS.ALERT_SOME_ERROR);
    }
  };

  return (
    <div className="welcome-page-container">
      {loader ? (
        <MainPageLoader />
      ) : (
        <>
          <div className="welcome-page-header">
            <Typography
              variant="body2"
              component="div"
            >{`${LANDING_PAGE_CONSTANTS.WELCOME} ${firstName}`}</Typography>
            <div className="welcome-page-search-container">
              <SearchInput
                id="schoolName"
                label={LANDING_PAGE_CONSTANTS.SEARCH_LABEL}
                value={searchString}
                style={{ width: MAX_WIDTH }}
                placeholder={LANDING_PAGE_CONSTANTS.SEARCH_PLACEHOLDER}
                onChange={onSearch}
              />
            </div>
          </div>
          <LandingPageAGgrid
            studentDetails={studentValueList}
            onboardMerchants={onboardMerchants}
            {...props}
            onSync={onSync}
          />
          <div className="table-footer-container">
            <CustomTableFooter
              pageNo={pageNo}
              pageSize={pageSize}
              totalCount={totalCount}
              onPageSizeChanged={onPageSizeChanged}
              onLeftArrow={onLeftArrow}
              onRightArrow={onRightArrow}
            />
          </div>
        </>
      )}
    </div>
  );
};

WelcomePage.propTypes = {
  pageSize: PropTypes.number,
  onPageSizeChanged: PropTypes.func,
  pageNo: PropTypes.number,
  totalCount: PropTypes.number,
  onLeftArrow: PropTypes.func,
  onRightArrow: PropTypes.func,
  searchString: PropTypes.string,
  onSearch: PropTypes.func,
  studentValueList: PropTypes.array,
  onSync: PropTypes.func,
  loader: PropTypes.bool,
};

export default WelcomePage;
